import React from "react";

const CompactNumber = (props) => {
    return (
        <div className={'compactNumber '+ (props.number ? '': 'bottomBorderSolid1')}>
            {props.number}
        </div>
    );
};

export default CompactNumber;